import styled from 'styled-components'

export const P = styled.p`
opacity: 0.8;
margin: 0 20px;
line-height: 30px;
`;

export const H1 = styled.h1`
opacity: 0.7;
color: #003263;
margin-left:20px;
weight: 900;
`;

export const H2 = styled.h2`
color: #003263;
opacity: 0.7;
margin-left: 20px;
`;

export const H4 = styled.h4`
color: #003263;
opacity: 0.7;
margin-left: 20px;
`;

export const HR = styled.hr`
color: pink;
border-top: 1px solid #6d6d6d;
margin-left: 20px;
margin-right: 20px;
`;
// Remove default settings
export const Ul = styled.ul`
list-style-type: none;
margin: 0;
padding: 0 20px;
`;

// Best way to remove user style agent
export const A = styled.a`
  text-decoration: none;
  color: inherit;
`;

export const Li = styled.li`
font-size: 16px;
`;




// WEBPACK FOOTER //
// ./src/components/Global/Typography.js